<template>
  <div class="page-break">
    <el-row>
      <el-col :span="24">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">{{ printName ? printName :
            topData[0].SUPPLIER_NAME
        }}送货验收单</h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:30px;">
      <!-- <el-col>
            <p style="font-size: 24px;text-align: center"></p>
        </el-col> -->
      <el-col v-if="topData.length > 0" :span="12">
        <ul>
          <li>项&nbsp;&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ topData[0].PROJECT_NAME }}</li>
          <li>项&nbsp;目&nbsp;地&nbsp;址：{{ topData[0].PROJECT_ADDRESS }}</li>
          <li v-if="AGENT == 0">制&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}</li>
          <li>回&nbsp;单&nbsp;日&nbsp;期：</li>
        </ul>
      </el-col>
      <el-col :span="12" style="padding-left: 15px;">
        <ul>
          <li>档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：{{ topData[0].DK_NAME }}</li>
          <li>{{ topData[0].PROJECT_TELPHONE }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号：{{ topData[0].ORDER_CODE }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="23" style="position:relative;">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th>编码</th>
            <th style="width: 40%">名称</th>
            <th style="width: 5%">单位</th>
            <th style="width: 10%">订购</th>
            <th style="width: 10%">实收</th>
            <th style="width: 10%">加工/生产日期</th>
            <th style="width: 10%">保质期</th>
            <th style="width: 15%">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.PRODUCT_CODE }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
      <el-col :span="1">
        <div style=" position:absolute;right: 1%;display:flex;flex-direction: column;font-size:0;">
          <span style="font-size:15px">白</span>
          <span style="font-size:15px">联</span>
          <span style="font-size:15px">存</span>
          <span style="font-size:15px">根</span>
          <div style="height:5px;"> </div>
          <span style="font-size:15px">红</span>
          <span style="font-size:15px">联</span>
          <span style="font-size:15px">财</span>
          <span style="font-size:15px">务</span>
          <div style="height:5px;"></div>
          <span style="font-size:15px">蓝</span>
          <span style="font-size:15px">联</span>
          <span style="font-size:15px">学</span>
          <span style="font-size:15px">校</span>
          <div style="height:5px;"> </div>
          <span style="font-size:15px">黄</span>
          <span style="font-size:15px">联</span>
          <span style="font-size:15px">仓</span>
          <span style="font-size:15px">库</span>
          <div style="height:5px;"> </div>
          <span style="font-size:15px">绿</span>
          <span style="font-size:15px">联</span>
          <span style="font-size:15px">公</span>
          <span style="font-size:15px">司</span>
        </div>
      </el-col>
      <!-- <div style=" position:absolute;right:6%;display:flex;flex-direction: column;font-size:0;">
        <span style="font-size:15px">白</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">存</span>
        <span style="font-size:15px">根</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">红</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">财</span>
        <span style="font-size:15px">务</span>
        <div style="height:5px;"></div>
        <span style="font-size:15px">蓝</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">学</span>
        <span style="font-size:15px">校</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">黄</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">仓</span>
        <span style="font-size:15px">库</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">绿</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">公</span>
        <span style="font-size:15px">司</span>
      </div> -->
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="5">
        <span>发货人员：</span>
      </el-col>
      <el-col :span="5">
        <span>送货人员：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
      <!-- <el-col :span="6">
        <span>本页金额：{{mainData[0].pageFee}}</span>
      </el-col>
      <el-col :span="6">
        <span>总&nbsp;金&nbsp;额：{{topData[0].REAL_TOTAL_SUPPLIER_FEE}}</span>
      </el-col> -->
    </el-row>
    <el-row>
      <el-col :span="5">
        <span>发货时间：</span>
      </el-col>
      <el-col :span="5">
        <span>送货线路：{{ topData[0].LINE_NAME }}</span>
      </el-col>
      <el-col :span="6">
        <span>验收时间：</span>
      </el-col>
      <el-col :span="6">
        <span
          style="margin-left: 110px;font-size: 20px;">第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</span>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
import date from '@/assets/common/date';

export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      printName: sessionStorage.getItem('supplierName'),
      countFlag: sessionStorage.getItem('countFlag'),
      printRealFlag: sessionStorage.getItem('printRealFlag'),
      currentDate: date(new Date(), '%F'),
      AGENT: 0,
    };
  },
  created() {
    this.AGENT = sessionStorage.getItem('AGENT');
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 20px;
  line-height: 22px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 24px;
  font-family: 黑体;
  color: #000;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/sellOrderFivePrintTax.vue